import { MemoizedTaskNode } from '../MemoizedNodes';
import sharedEditorCallbacks from '../utils/sharedEditorCallbacks';

export default function TaskNodeItem({
  task,
  commonProps,
  handlers,
  props,
  lockStates,
  statuses,
  allCategories,
  allTags,
  allTasks,
  nestedSprintMap,
  nestedSprints,
  allSprints,
  onOpenNestedSprint,
  onCreateNestedSprint,
  onDeliverablesChange,
  onInputsChange,
  onDependencyChange,
  onSetStatusAutoSync,
  onExplodeNestedCampaign,
}) {
  return (
    <MemoizedTaskNode
      {...commonProps}
      {...sharedEditorCallbacks(props, handlers)}
      statuses={statuses}
      lockState={lockStates[task.id]}
      allCategories={allCategories}
      allTags={allTags}
      allTasks={allTasks}
      nestedSprint={task.nestedSprintId ? nestedSprintMap[task.nestedSprintId] : null}
      nestedSprints={nestedSprints}
      allSprints={allSprints}
      onOpenNestedSprint={onOpenNestedSprint}
      onCreateNestedSprint={onCreateNestedSprint}
      onRemoveNestedSprint={handlers.onRemoveNestedSprint}
      onDeliverablesChange={onDeliverablesChange}
      onInputsChange={onInputsChange}
      onDependencyChange={onDependencyChange}
      onSetStatusAutoSync={onSetStatusAutoSync}
      onExplodeNestedCampaign={onExplodeNestedCampaign}
    />
  );
}
